@if (model$ | async; as model) {
  <div class="cx-page product-list">
    <section class="cx-page-section">
      <div class="container">
        <div class="row">
          @if (viewMode$ | async; as viewMode) {
            <div class="col-12 col-lg-12">
              <div class="cx-sorting top">
                <div class="row">
                  <div class="col-12 col-lg-4 mr-auto">
                    <div class="form-group cx-sort-dropdown">
                      @if (model?.products.length > 0) {
                        <cx-sorting
                          [sortOptions]="model.sorts"
                          (sortListEvent)="sortList($event)"
                          [selectedOption]="model.pagination.sort"
                          placeholder="{{ 'productList.sortByRelevance' | cxTranslate }}"
                        ></cx-sorting>
                      }
                    </div>
                  </div>
                  @if (!isInfiniteScroll) {
                    <div class="col-auto">
                      <div class="cx-pagination" aria-label="product search pagination">
                        <cx-pagination
                          [pagination]="model.pagination"
                          queryParam="currentPage"
                          [defaultPage]="0"
                        ></cx-pagination>
                      </div>
                    </div>
                  }
                  @if (showPageView) {
                    <div class="col-auto ml-auto ml-lg-0">
                      <app-custom-product-view (modeChange)="setViewMode($event)" [mode]="viewMode"></app-custom-product-view>
                    </div>
                  }
                </div>
              </div>
              <div class="cx-product-container">
                <!-- Product list when using pagination -->
                @if (!isInfiniteScroll) {
                  @if (viewMode === ViewModes.Grid) {
                    <div class="row">
                      @for (product of model?.products; track product) {
                        <app-custom-product-grid-item
                          [product]="product"
                          class="col-12 col-sm-6 col-md-4"
                        ></app-custom-product-grid-item>
                      }
                    </div>
                  }
                  @if (viewMode === ViewModes.List) {
                    @for (product of model?.products; track product) {
                      <app-custom-product-list-item
                        [product]="product"
                        class="cx-product-search-list"
                      ></app-custom-product-list-item>
                    }
                  }
                } @else {
                  <app-product-scroll
                    [scrollConfig]="scrollConfig"
                    [model]="model"
                    [inputViewMode]="viewMode"
                  ></app-product-scroll>
                }
                <!-- Product list when using infinite scroll -->
              </div>
              <div class="cx-sorting bottom">
                <div class="row">
                  <div class="col-12 col-lg-4 mr-auto">
                    <div class="form-group cx-sort-dropdown">
                      @if (model?.products.length > 0) {
                        <cx-sorting
                          [sortOptions]="model.sorts"
                          (sortListEvent)="sortList($event)"
                          [selectedOption]="model.pagination.sort"
                          placeholder="{{ 'productList.sortByRelevance' | cxTranslate }}"
                        ></cx-sorting>
                      }
                    </div>
                  </div>
                  @if (!isInfiniteScroll) {
                    <div class="col-auto" aria-label="product search pagination">
                      <div class="cx-pagination">
                        <cx-pagination
                          [pagination]="model.pagination"
                          queryParam="currentPage"
                          [defaultPage]="0"
                          (viewPageEvent)="scrollToTop()"
                        ></cx-pagination>
                      </div>
                    </div>
                  }
                  @if (showPageView) {
                    <div class="col-auto ml-auto ml-lg-0">
                      <app-product-view (modeChange)="setViewMode($event)" [mode]="viewMode"> </app-product-view>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </section>
  </div>
}

@if (selectedProducts | async; as selectedProducts) {
  <section [hidden]="selectedProducts.length === 0" #compareContainer class="compare-container">
    <div class="container compare-container__title-container">
      <div class="row">
        <div class="col-9 col-sm-6 col-md-9 compare-container__title-container__title">
          <h3>Compare products</h3>
        </div>
        <div class="col-3 col-sm-6 col-md-3 compare-container__compare-button">
          <button class="btn btn-primary" (click)="onCompareProducts(selectedProducts)">Compare products</button>
        </div>
      </div>
    </div>
    <div class="container compare-container__buttons-container">
      <div class="row">
        <div class="compare-container__buttons">
          @for (selectedProduct of selectedProducts; track selectedProduct) {
            <app-action-button
              [product]="selectedProduct"
              [closeButton]="true"
              (removeProductToCompare)="removeProductToCompare($event)"
              [title]="selectedProduct.name"
              [image]="selectedProduct.images?.PRIMARY || selectedProduct.images"
              >
              {{ selectedProducts }}</app-action-button
              >
            }
          </div>
        </div>
      </div>
    </section>
  }
